import React, { useState, useEffect } from "react";
import "./maintenanceDowntime.scss";
import HeaderLanding from "../header/headerLanding";
import Sidebar from "../sidebar/sidebar";
import rocketLogo from "../../../../common/assets/rocketLogo.svg";
import { useNavigate } from "react-router-dom";
import { AppState } from "../../../../common/store/combinedReducer";
import { useSelector, useDispatch } from "react-redux";
import { getPermissions } from "../../../store/action";
import AuthProvider from "../../../../common/authentication/authService";

const MaintenanceDowntime: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userDetail: any = useSelector((state: AppState) => {
    return state.reducer.userInfo;
  });

  useEffect(() => {
    if (!userDetail || !userDetail.email) {
      const sub: any = AuthProvider().getUserId();
      if (sub) {
        dispatch(
          getPermissions({
            userSub: sub,
            authorization: localStorage.getItem("access_token"),
          }),
        );
      }
    }
  }, [userDetail, dispatch]);

  return (
    <div className="maintenance-downtime">
      <div className="header-landing">
        <HeaderLanding
          onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
          sidebarOpen={sidebarOpen}
          profileOnly
        />
      </div>
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        hideManagementTabs
      />
      <div className="maintenance-downtime-overlay">
        <div className="maintenance-downtime-error-text">
          <img
            src={rocketLogo}
            alt="Layer 1"
            className="maintenance-downtime-image"
          />
          SITE IS UNDER MAINTENANCE.
          <div className="maintenance-downtime-secondary-text">
            Please try again later.
          </div>
          <button
            className="maintenance-downtime-home-btn"
            onClick={() => navigate("/dashboard")}
          >
            Go To Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceDowntime;
